import React, { useState, useRef, useEffect } from "react";

const RecipeCard = ({ recipe, lazyLoad = false }) => {
  const [imageLoaded, setImageLoaded] = useState(!lazyLoad);
  const [imageSrc, setImageSrc] = useState(lazyLoad ? "" : recipe.image);
  const imageRef = useRef(null);

  useEffect(() => {
    if (!lazyLoad) {
      setImageSrc(recipe.image);
      setImageLoaded(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageSrc(recipe.image);
            setImageLoaded(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '50px', // Start loading when within 50px
        threshold: 0.1
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, [recipe.image, lazyLoad]);

  return (
    <a
      href={recipe.url}
      target="_blank"
      className="tw-w-full tw-block tw-h-full"
    >
      <div 
        ref={imageRef}
        className="tw-aspect-square tw-w-full tw-rounded-2xl tw-overflow-hidden tw-bg-white dark:tw-bg-gray-900 tw-relative"
      >
        {lazyLoad && !imageLoaded && (
          <div className="tw-absolute tw-inset-0 tw-bg-gray-200 dark:tw-bg-gray-700 tw-flex tw-items-center tw-justify-center">
            <div className="tw-loader tw-border-2 tw-border-gray-300 tw-border-t-blue-600 tw-rounded-full tw-w-6 tw-h-6 tw-animate-spin"></div>
          </div>
        )}
        {imageSrc && (
          <img
            src={imageSrc}
            alt={recipe.title}
            className={`tw-w-full tw-h-full tw-object-cover tw-rounded-2xl tw-mb-4 tw-transition-opacity tw-duration-300 ${
              imageLoaded ? 'tw-opacity-100' : 'tw-opacity-0'
            }`}
            onLoad={() => setImageLoaded(true)}
            loading={lazyLoad ? "lazy" : "eager"}
          />
        )}
      </div>
      <h3 className="tw-mt-4 tw-text-lg tw-overflow-hidden tw-h-[3em] tw-leading-snug tw-text-ellipsis tw-break-words tw-text-black dark:tw-text-white">
        {recipe.title}
      </h3>
    </a>
  );
};

export default RecipeCard;
